import { useState } from 'react'
import { useMutation, useQueryClient } from '@tanstack/react-query'

import { supabase } from '@/lib/supabase/cliente'
import { mensajeDeError } from '@/lib/supabase/errores'

import estilos from './EditarDireccion.module.css'

/**
 * LA DIRECCIÓN DE LA ORDEN, EDITABLE DESDE LA FICHA (0321).
 *
 * Permite corregir la dirección textual de la orden sin mandarlo a otra pantalla.
 * La bitácora registra el valor anterior y quién realizó el cambio.
 */
export function EditarDireccion({
  ordenServicioId,
  direccion,
  puedeEditar,
}: {
  ordenServicioId: string
  direccion: string | null
  puedeEditar: boolean
}) {
  const cliente = useQueryClient()
  const [editando, setEditando] = useState(false)
  const [texto, setTexto] = useState(direccion ?? '')

  const guardar = useMutation({
    mutationFn: async () => {
      const { error } = await supabase.rpc('fn_editar_direccion_orden', {
        p_orden_servicio_id: ordenServicioId,
        p_direccion: texto.trim(),
      })
      if (error) throw new Error(mensajeDeError(error))
    },
    onSuccess: async () => {
      await cliente.invalidateQueries({ queryKey: ['ordenes-servicio'] })
      await cliente.invalidateQueries({ queryKey: ['bitacora'] })
      setEditando(false)
    },
  })

  if (!editando) {
    return (
      <div className={estilos.vista}>
        <span className={estilos.texto}>{direccion ?? 'Sin dirección.'}</span>
        {puedeEditar && (
          <button
            type="button"
            className={estilos.editar}
            onClick={() => {
              setTexto(direccion ?? '')
              guardar.reset()
              setEditando(true)
            }}
          >
            Editar
          </button>
        )}
      </div>
    )
  }

  return (
    <div className={estilos.edicion}>
      <input
        type="text"
        className={estilos.campo}
        value={texto}
        onChange={(e) => setTexto(e.target.value)}
        autoFocus
        maxLength={250}
        aria-label="Dirección de la orden"
        placeholder="Ej: CL 4 6 25 BRR CAMELLON DEL QUINDIO"
      />
      {guardar.error && <p className={estilos.error}>{guardar.error.message}</p>}
      <div className={estilos.botones}>
        <button
          type="button"
          className={estilos.principal}
          onClick={() => guardar.mutate()}
          disabled={guardar.isPending || texto.trim().length < 4}
        >
          {guardar.isPending ? 'Guardando…' : 'Guardar'}
        </button>
        <button
          type="button"
          className={estilos.secundario}
          onClick={() => setEditando(false)}
        >
          Cancelar
        </button>
        <span className={estilos.nota}>Queda en la bitácora lo que decía antes.</span>
      </div>
    </div>
  )
}

